import { render } from "./Bin.vue?vue&type=template&id=3676a0bd&scoped=true"
import script from "./Bin.vue?vue&type=script&lang=js"
export * from "./Bin.vue?vue&type=script&lang=js"

import "./Bin.vue?vue&type=style&index=0&id=3676a0bd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3676a0bd"

export default script